import React, { useCallback, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import api from '../api/client';
import { useAuth } from '../context/AuthContext';
import PanelTabs, { StaffHead } from '../components/ui/PanelTabs';
import { STAFF_TABS } from '../constants/botNav';
import ModerationTab from './admin/ModerationTab';
import LeaderboardTab from './admin/LeaderboardTab';
import ChangelogAdmin from './admin/ChangelogAdmin';
import LibrarySwitchCard from './admin/LibrarySwitchCard';
import AccountsTab from './admin/AccountsTab';
import InvitesTab from './admin/InvitesTab';
import TasksTab from './admin/TasksTab';

/**
 * A bot oldalának stáb-lapja (/staff?tab=…, admin és owner): route-moderálás, farm-ranglista, a changelog szerkesztője
 * és (owner) a route-könyvtár kapcsolója. A Library review a Dashboardon van (a tester is moderál).
 * 2026-10-08: Accounts — az app-belépések, a HWID-reset (CSAK itt) és a meghívó-kódok. A többi fiók-kezelés (tiltás,
 * előfizetés, napló) a Codex adminjában van.
 * 2026-10-11: Bot tasks és Launcher tasks — a stáb feladat-táblája (pages/admin/TasksTab.jsx); a fülön a nyitott
 * tételek száma.
 */
export default function StaffPage() {
  const { user } = useAuth();
  const [params, setParams] = useSearchParams();
  const [taskCounts, setTaskCounts] = useState({});

  const loadTaskCounts = useCallback(async () => {
    try {
      const res = await api.get('/admin/tasks/counts');
      setTaskCounts(res.data.counts || {});
    } catch {
      /* a számláló elhagyható: hiba esetén a fül szám nélkül látszik */
    }
  }, []);
  useEffect(() => { loadTaskCounts(); }, [loadTaskCounts]);

  const tabs = STAFF_TABS
    .filter(t => !t.owner || user?.role === 'owner')
    .map(t => (t.product ? { ...t, count: taskCounts[t.product] || 0 } : t));
  const active = tabs.find(t => t.id === params.get('tab'))?.id || tabs[0].id;
  const taskTab = tabs.find(t => t.id === active && t.product);

  return (
    <div className="wrap pb-20 sm:pb-28">
      <StaffHead
        title="Staff"
        subtitle={<>Signed in as <span className="text-gray-100">{user?.username}</span> ({user?.role})</>}
        badge={user?.role === 'owner' ? 'Owner' : 'Admin'}
      />
      <PanelTabs
        className="mt-[18px] mb-8"
        active={active}
        onChange={(id) => setParams({ tab: id }, { replace: true })}
        tabs={tabs}
      />
      {active === 'accounts' && <AccountsTab />}
      {active === 'invites' && <InvitesTab />}
      {active === 'moderation' && <ModerationTab />}
      {active === 'leaderboard' && <LeaderboardTab />}
      {active === 'changelog' && <ChangelogAdmin />}
      {taskTab && (
        <TasksTab key={taskTab.product} product={taskTab.product} title={taskTab.label} onChanged={loadTaskCounts} />
      )}
      {active === 'settings' && <LibrarySwitchCard />}
    </div>
  );
}
